module.exports = __webpack_public_path__ + "img/bookshelf_huihua.a39aafe8.png";